export default "__VITE_ASSET__Dplr98zz__"